var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeCritico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 63,
    viewBox: "0 0 56 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 31.5213C36.592 31.5213 43.5555 24.4908 43.5555 15.8162C43.5555 7.14158 36.592 0.111084 28 0.111084C19.408 0.111084 12.4444 7.14158 12.4444 15.8162C12.4444 24.4908 19.408 31.5213 28 31.5213ZM39.6424 35.5212L33.8333 59.0053L29.9444 42.3186L33.8333 35.4476H22.1667L26.0555 42.3186L22.1667 59.0053L16.3576 35.5212C7.6927 35.9384 0.777771 43.0916 0.777771 51.938V57.0422C0.777771 60.2936 3.39062 62.9316 6.6111 62.9316H49.3889C52.6094 62.9316 55.2222 60.2936 55.2222 57.0422V51.938C55.2222 43.0916 48.3073 35.9384 39.6424 35.5212Z",
    fill: "#E18787"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeCritico);
export default __webpack_public_path__ + "static/media/IconeCritico.1ff375c0c3ff0aff0f5b2ef8303f3564.svg";
export { ForwardRef as ReactComponent };